export default {
  exampleRoute: {
    title: 'Sammenlign lån og finn det billigste lånet på zmarta.no | Zmarta',
    description: 'Sammenlign lån på Zmarta.no for å finne det billigste lånet på nett! Vi hjelper deg med å finne de beste alternativene på lån for nettopp dine behov og penger.',
    keywords: '',
    canonical: '/example-route',
    robots: 'noindex, nofollow'
  }
}
